import { createSlice } from "@reduxjs/toolkit";

export const deliveries = createSlice({
  name: "deliveries",
  initialState: {
    value: false,
  },
  reducers: {
    setDeliveries: (state, { payload }) => {
      state.value = payload;
    },
  },
});

export const { setDeliveries } = deliveries.actions;
export default deliveries.reducer;
